// extracted by mini-css-extract-plugin
export default {"separator":"Separator_separator__YfAx6","noBorder":"Separator_noBorder__eDDyA","noMargin":"Separator_noMargin__arxWl"};